import { Observable } from 'rxjs';

export abstract class SuperTableSelectable<T> {
  abstract select(value: T | null, selected: boolean): void;
  abstract selected(value: T): Observable<boolean>;
}
